import React from "react";

export type ProductItemTilesStyle = "featured" | "clearance" | "signature" | "australian";

export type ProductItemTilesToken = {
    section: React.CSSProperties;
    eyebrow: React.CSSProperties;
    title: React.CSSProperties;
    description: React.CSSProperties;
    badge: React.CSSProperties;
    scrollHint: React.CSSProperties;
    scrollHintText: React.CSSProperties;
    scrollHintIcon: React.CSSProperties;
    ctaWrap: React.CSSProperties;
    ctaButton: React.CSSProperties;
    accentLine: React.CSSProperties;
};

export const productItemTilesTokens: Record<ProductItemTilesStyle, ProductItemTilesToken> = {
    featured: {
        section: {
            padding: 18,
            borderRadius: 24,
            border: "1px solid rgba(217, 119, 6, 0.22)",
            background:
                "linear-gradient(135deg, rgba(255,247,237,0.98), rgba(255,255,255,0.98) 58%, rgba(254,243,199,0.72))",
            boxShadow: "0 18px 45px rgba(120, 53, 15, 0.10)",
        },
        eyebrow: { color: "#b45309" },
        title: { color: "#111827" },
        description: { color: "rgba(17,24,39,0.72)" },
        badge: {
            display: "inline-flex",
            alignItems: "center",
            gap: 7,
            width: "fit-content",
            borderRadius: 999,
            padding: "7px 11px",
            fontSize: 12,
            fontWeight: 800,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: "#92400e",
            background: "rgba(251, 191, 36, 0.20)",
            border: "1px solid rgba(217, 119, 6, 0.22)",
        },
        scrollHint: {
            position: "absolute",
            right: 8,
            top: "50%",
            zIndex: 3,
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            transform: "translateY(-50%)",
            borderRadius: 999,
            padding: "9px 12px",
            background: "rgba(17,24,39,0.90)",
            color: "#ffffff",
            boxShadow: "0 10px 26px rgba(17,24,39,0.22)",
            pointerEvents: "none",
            animation: "productItemTilesSliderHint 1.45s ease-in-out infinite",
        },
        scrollHintText: {
            fontSize: 12,
            fontWeight: 800,
            lineHeight: 1,
            whiteSpace: "nowrap",
        },
        scrollHintIcon: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 24,
            height: 24,
            borderRadius: 999,
            background: "rgba(255,255,255,0.18)",
        },
        ctaWrap: {
            display: "flex",
            justifyContent: "flex-start",
            paddingTop: 2,
        },
        ctaButton: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 8,
            borderRadius: 4,
            padding: "12px 18px",
            background: "#111827",
            color: "#ffffff",
            border: "1px solid #111827",
            fontSize: 14,
            fontWeight: 800,
            lineHeight: 1,
            textDecoration: "none",
            boxShadow: "0 12px 24px rgba(17,24,39,0.18)",
        },
        accentLine: {
            position: "absolute",
            inset: "auto 18px 0 18px",
            height: 3,
            borderRadius: 999,
            background: "linear-gradient(90deg, #f59e0b, #f97316, #111827)",
        },
    },
    clearance: {
        section: {
            padding: 18,
            borderRadius: 24,
            border: "1px solid rgba(220, 38, 38, 0.22)",
            background:
                "linear-gradient(135deg, rgba(254,242,242,0.98), rgba(255,255,255,0.98) 56%, rgba(255,237,213,0.78))",
            boxShadow: "0 18px 45px rgba(127, 29, 29, 0.10)",
        },
        eyebrow: { color: "#dc2626" },
        title: { color: "#b91c1c" },
        description: { color: "rgba(17,24,39,0.72)" },
        badge: {
            display: "inline-flex",
            alignItems: "center",
            gap: 7,
            width: "fit-content",
            borderRadius: 4,
            padding: "6px 9px",
            fontSize: 12,
            fontWeight: 900,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: "#991b1b",
            background: "rgba(248, 113, 113, 0.16)",
            border: "1px solid rgba(220, 38, 38, 0.24)",
        },
        scrollHint: {
            position: "absolute",
            right: 8,
            top: "50%",
            zIndex: 3,
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            transform: "translateY(-50%)",
            borderRadius: 999,
            padding: "8px 11px",
            background: "rgba(255,255,255,0.92)",
            color: "#b91c1c",
            border: "1px solid rgba(220, 38, 38, 0.14)",
            boxShadow: "0 10px 22px rgba(127,29,29,0.10)",
            pointerEvents: "none",
            animation: "productItemTilesSliderHint 1.9s ease-in-out infinite",
        },
        scrollHintText: {
            fontSize: 12,
            fontWeight: 900,
            lineHeight: 1,
            whiteSpace: "nowrap",
        },
        scrollHintIcon: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 24,
            height: 24,
            borderRadius: 999,
            background: "rgba(220, 38, 38, 0.10)",
        },
        ctaWrap: {
            display: "flex",
            justifyContent: "flex-start",
            paddingTop: 2,
        },
        ctaButton: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 8,
            borderRadius: 4,
            padding: "12px 18px",
            background: "#991b1b",
            color: "#ffffff",
            border: "1px solid #991b1b",
            fontSize: 14,
            fontWeight: 900,
            lineHeight: 1,
            textDecoration: "none",
            boxShadow: "0 12px 24px rgba(127,29,29,0.18)",
        },
        accentLine: {
            position: "absolute",
            inset: "auto 18px 0 18px",
            height: 3,
            borderRadius: 999,
            background: "linear-gradient(90deg, #dc2626, #f97316, #111827)",
        },
    },
    signature: {
        section: {
            padding: 18,
            borderRadius: 24,
            border: "1px solid rgba(0,0,0,0.08)",
            background:
                "linear-gradient(135deg, rgba(250,250,250,0.98), rgba(255,255,255,0.98))",
            boxShadow: "0 16px 40px rgba(0,0,0,0.08)",
        },
        eyebrow: { color: "rgba(17,17,17,0.6)" },
        title: { color: "#111111", letterSpacing: "0.4px" },
        description: { color: "rgba(17,17,17,0.72)" },
        badge: {
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            width: "fit-content",
            borderRadius: 4,
            padding: "4px 8px",
            fontSize: 11,
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.06em",
            background: "#111111",
            color: "#ffffff",
        },
        scrollHint: {
            position: "absolute",
            right: 8,
            top: "50%",
            zIndex: 3,
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            transform: "translateY(-50%)",
            borderRadius: 999,
            padding: "8px 11px",
            background: "rgba(255,255,255,0.92)",
            color: "#111111",
            border: "1px solid rgba(17,17,17,0.08)",
            boxShadow: "0 10px 22px rgba(0,0,0,0.08)",
            pointerEvents: "none",
            animation: "productItemTilesSliderHint 1.9s ease-in-out infinite",
        },
        scrollHintText: {
            fontSize: 12,
            fontWeight: 700,
            lineHeight: 1,
            whiteSpace: "nowrap",
        },
        scrollHintIcon: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 24,
            height: 24,
            borderRadius: 999,
            background: "rgba(17,17,17,0.06)",
        },
        ctaWrap: {
            display: "flex",
            justifyContent: "flex-start",
            paddingTop: 2,
        },
        ctaButton: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 8,
            borderRadius: 4,
            padding: "12px 18px",
            background: "#111111",
            color: "#ffffff",
            border: "1px solid #111111",
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1,
            textDecoration: "none",
            boxShadow: "0 10px 20px rgba(0,0,0,0.10)",
        },
        accentLine: {
            position: "absolute",
            inset: "auto 18px 0 18px",
            height: 2,
            borderRadius: 999,
            background: "rgba(17,17,17,0.2)",
        },
    },
    australian: {
        section: {
            padding: 18,
            borderRadius: 24,
            border: "1px solid rgba(30, 64, 175, 0.20)",
            background:
                "linear-gradient(135deg, rgba(239,246,255,0.98), rgba(255,255,255,0.98) 58%, rgba(219,234,254,0.72))",
            boxShadow: "0 18px 45px rgba(30, 64, 175, 0.10)",
        },
        eyebrow: { color: "#1e40af" },
        title: { color: "#1e40af" },
        description: { color: "rgba(17,24,39,0.72)" },
        badge: {
            display: "inline-flex",
            alignItems: "center",
            gap: 7,
            width: "fit-content",
            borderRadius: 4,
            padding: "6px 9px",
            fontSize: 12,
            fontWeight: 850,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: "#1e3a8a",
            background: "rgba(30, 64, 175, 0.10)",
            border: "1px solid rgba(30, 64, 175, 0.18)",
        },
        scrollHint: {
            position: "absolute",
            right: 8,
            top: "50%",
            zIndex: 3,
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            transform: "translateY(-50%)",
            borderRadius: 999,
            padding: "8px 11px",
            background: "rgba(255,255,255,0.92)",
            color: "#1e40af",
            border: "1px solid rgba(30, 64, 175, 0.14)",
            boxShadow: "0 10px 22px rgba(30,64,175,0.10)",
            pointerEvents: "none",
            animation: "productItemTilesSliderHint 1.9s ease-in-out infinite",
        },
        scrollHintText: {
            fontSize: 12,
            fontWeight: 850,
            lineHeight: 1,
            whiteSpace: "nowrap",
        },
        scrollHintIcon: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 24,
            height: 24,
            borderRadius: 999,
            background: "rgba(30, 64, 175, 0.10)",
        },
        ctaWrap: {
            display: "flex",
            justifyContent: "flex-start",
            paddingTop: 2,
        },
        ctaButton: {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 8,
            borderRadius: 4,
            padding: "12px 18px",
            background: "#1e40af",
            color: "#ffffff",
            border: "1px solid #1e40af",
            fontSize: 14,
            fontWeight: 850,
            lineHeight: 1,
            textDecoration: "none",
            boxShadow: "0 12px 24px rgba(30,64,175,0.18)",
        },
        accentLine: {
            position: "absolute",
            inset: "auto 18px 0 18px",
            height: 3,
            borderRadius: 999,
            background: "linear-gradient(90deg, #1e40af, #60a5fa, #111827)",
        },
    },
};
